import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@affinite/common';
import { RefreshComponent } from './refresh.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule
  ],
  declarations: [
    RefreshComponent
  ],
  exports: [
    RefreshComponent
  ]
})
export class RefreshModule { }
